import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withAlert } from 'react-alert';
import PropTypes from 'prop-types';
import { requestForgetPassword } from '../../Actions/actions';
import Header from '../Header/header';

class AffiliatePage extends React.Component {
  render() {
    const { location: { pathname } } = this.props;
    // console.log('dthis.props',this.props)
    // console.log('session-expired', pathname);


    return (
      <span>
        <div className="container">
          <div className="main-content">
            <Header />

            <div className="section-content center-align login-content">
              <p>{pathname === '/session-expired' ? 'Session has expired.' : 'Application link has been expired.'}</p>
              <h5>
                Click here to
                {' '}
                <Link to={pathname === '/session-expired' ? '/' : '/signup'}>{pathname === '/session-expired' ? 'Login' : 'sign up' }</Link>
              </h5>

              <div className="row">
                <div className="row">
                  <div className="col s12">
                    <div className="create-account" />
                  </div>

                </div>
              </div>

            </div>

          </div>

        </div>

      </span>
    );
  }
}

AffiliatePage.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators({ requestForgetPassword }, dispatch);

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(AffiliatePage));
